export default "__VITE_ASSET__CrihtLgl__"